import React from 'react';
import { LicenseStatus, CreditSummary } from '../customerDetailsTypes';
import styles from './LicenseCreditCards.module.css';

interface LicenseCreditCardsProps {
  license: LicenseStatus;
  credit: CreditSummary;
}

export const LicenseCreditCards: React.FC<LicenseCreditCardsProps> = ({
  license,
  credit,
}) => {
  return (
    <div className={styles.row}>
      <div className={styles.card}>
        <h3 className={styles.title}>License Status</h3>
        <div className={styles.statusRow}>
          <span className={styles.label}>Status</span>
          <span className={`${styles.badge} ${styles[`badge_${license.status.toLowerCase()}`]}`}>
            {license.status}
          </span>
        </div>
        <p className={styles.muted}>Expiry Date</p>
        <p className={styles.value}>{license.expiryDate}</p>
      </div>

      <div className={styles.card}>
        <div className={styles.creditHeader}>
          <h3 className={styles.title}>Credit & Payment Summary</h3>
          {credit.withinLimit && (
            <span className={styles.withinLimit}>✓ Within credit limit</span>
          )}
        </div>
        <div className={styles.creditRow}>
          <span className={styles.label}>Credit Limit</span>
          <span className={styles.creditValue}>{credit.creditLimit}</span>
        </div>
        <div className={styles.creditRow}>
          <span className={styles.label}>Outstanding Amount</span>
          <span className={styles.creditValue}>{credit.outstanding}</span>
        </div>
        <div className={styles.bar}>
          <span className={styles.barFill} style={{ width: `${credit.utilizationPct}%` }} />
        </div>
      </div>
    </div>
  );
};
